import { VStack, Box, Text, View } from 'native-base';
import { UserAvatar } from '../../';
import { User } from '@breakroom-nx/classes';
export interface AnonymousProfileProps {
  user: User;
}

export function AnonymousProfile({ user }: AnonymousProfileProps) {
  return (
    <VStack alignItems={'center'} space={5}>
      <Box alignItems={'center'}>
        <UserAvatar uid={user.uid} size={90} disabled={true} noBorder/>
      </Box>
      <Text
        fontSize={25}
        lineHeight={30}
        variant={'usernameProfile'}
        color={user.theme}
        isTruncated
      >
        {user.username}
      </Text>
      <View
        rounded={'full'}
        borderWidth={1}
        borderColor={'surface.500'}
        px={5}
        py={2.5}
      >
        <Text variant={'usernameProfile'} color={'surface.500'} isTruncated>
          Anonymous
        </Text>
      </View>
    </VStack>
  );
}

export default AnonymousProfile;
